import React, {ReactNode} from "react";
import {Image} from "./Image";
import {useConfig} from "./hooks/useConfig";

export interface Item {
    id: string
    url: string
}

export type SmileType = 'none' | 'image' | 'smile'

export interface Category {
    index: number
    type: SmileType
    title: string
    dir?: string
    items: Item[]
}

export interface ImagesProps {
    categories: Category[]
    onClipboard: (type: SmileType, url: string) => void
}

export const Images = (props: ImagesProps) => {
    const config = useConfig()

    const elements: ReactNode[] = []

    props.categories.forEach((category) => {
        const children: ReactNode[] = category.items.map(item => {
            switch(category.type) {
                case 'image': {
                    const imageUrl = config.storageBaseUrl + '/' + encodeURI(category.dir || '') + '/' + encodeURI(item.id)

                    return (
                        <Image key={item.id} type={category.type} url={imageUrl} data={imageUrl} onClipboard={props.onClipboard} />
                    )
                }
                case 'smile': {
                    return (
                        <Image key={item.id} type={category.type} url={item.url} data={item.id} onClipboard={props.onClipboard} />
                    )
                }
            }

            return <></>
        })

        const id = "cb-" + category.index

        const element = (
            <div key={category.index} className="tab">
                <input type="checkbox" id={id}/>
                <label htmlFor={id} className="tab__label">{category.title} ({category.items.length})</label>
                <div className="tab__content">
                    <div className="tab-images">
                        {children}
                    </div>
                </div>
            </div>
        )

        elements.push(element)
    })

    return (
        <>
            {elements}
        </>
    )
}